// newsletter-compact JS, extracted from theme.js so it only loads where the section/block renders.
// Shared helpers come from theme.js via window.flu.sectionHelpers.
const {
  delayOffset,
  intersectionWatcher,
  register,
  shouldAnimate,
  load,
} = window.flu.sectionHelpers;

const selectors$16 = {
  items: ".animation--section-blocks > *"
};
var animateNewsletterCompact = (node => {
  delayOffset(node, [selectors$16.items]);
  const observer = intersectionWatcher(node, true);
  return {
    destroy() {
      observer === null || observer === void 0 || observer.destroy();
    }
  };
});

register("newsletter-compact", {
  onLoad() {
    if (shouldAnimate(this.container)) {
      this.animateNewsletterCompact = animateNewsletterCompact(this.container);
    }
  },
  onUnload() {
    var _this$animateNewslett;
    (_this$animateNewslett = this.animateNewsletterCompact) === null || _this$animateNewslett === void 0 || _this$animateNewslett.destroy();
  }
});

load("newsletter-compact");
